import dynamic from 'next/dynamic';
import type { ReactElement } from 'react';
import React from 'react';

import CustomMetatag from '@/components/layouts/custom-metatag';
import Error, { ErrorProps } from '@/components/sections/error';

const Layout = dynamic(() => import('@/components/layouts/lcv'));

const ERROR_DATA: ErrorProps = {
  title: '404 - Isuzu TIS Laos',
  description: 'ຂໍອະໄພ ບໍ່ພົບໜ້າທີ່ທ່ານຊອກຫາ',
  buttons: [
    {
      label: 'ກັບຫນ້າທໍາອິດ',
      url: '/',
      icon: 'home',
    },
  ],
  imageMobile: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt0688e7d5f402f0b7/657bfb3548c8ab018912be04/laos-error_mobile.jpg',
    alt: '404',
    width: 1600,
    height: 1600,
  },
  imageDesktop: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltc0c42f48526a8d86/657bfb360f816d3eb74d43f7/laos_error_desktop.jpg',
    alt: '404',
    width: 1600,
    height: 600,
  },
};

export async function getStaticProps() {
  return {
    props: {},
  };
}

const Page = () => {
  return (
    <>
      <CustomMetatag
        title={ERROR_DATA.title}
        description={ERROR_DATA.description}
      />
      <Error {...ERROR_DATA} title="404" />
    </>
  );
};

export default Page;

Page.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};
